export default __webpack_public_path__ + "static/media/270.4896d258.png";